import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ResultsService } from '../services/results.service';
import {
  CreateReportGenerationItemAction,
  FinishReportGenerationItemAction,
} from '@app/modules/reports/store/report-generation.actions';
import { Result } from '@app/modules/reports/types/result.types';
import { ReportsState } from '@app/modules/reports/store/reports.state';
import { Report } from '@app/modules/reports/types/report.types';

const REPORT_GENERATION_STATE_NAME = 'ReportGeneration';

export interface ReportGenerationStateModel {
  reports: { [key: string]: ReportGenerationItem };
}

@State<ReportGenerationStateModel>({
  name: REPORT_GENERATION_STATE_NAME,
  defaults: {
    reports: {},
  },
})
@Injectable()
export class ReportGenerationState {
  @Selector([ReportGenerationState, ReportsState.getReport])
  static getGenerationItemsStatus(
    { reports }: ReportGenerationStateModel,
    getReport: (id) => Report
  ) {
    return (generationIds: string[]) => {
      return generationIds.map((generationId) => ({
        ...reports[generationId],
        report: getReport(reports[generationId].id),
      }));
    };
  }

  @Action(CreateReportGenerationItemAction)
  createReportGenerationItemAction(
    { patchState, getState }: StateContext<ReportGenerationStateModel>,
    { resultId, generationId, kitId }: CreateReportGenerationItemAction
  ) {
    patchState({
      reports: {
        ...getState().reports,
        [generationId]: { resultId, kitId, loading: true },
      },
    });
  }

  @Action(FinishReportGenerationItemAction)
  finishReportGenerationItemAction(
    { patchState, getState }: StateContext<ReportGenerationStateModel>,
    { generationId, data }: FinishReportGenerationItemAction
  ) {
    patchState({
      reports: {
        ...getState().reports,
        [generationId]: {
          ...getState().reports[generationId],
          ...data,
          loading: false,
        },
      },
    });
  }
}

export class ReportGenerationItem {
  resultId: string;
  kitId: string;
  loading: boolean;
  id?: string; // reportId
  errors?: string[];
}
